import { Capacitor } from "@capacitor/core";

/** True somente dentro do app iOS/Android (Capacitor). No navegador é sempre false. */
export const isNativeApp = (): boolean => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

export const nativePlatform = (): "ios" | "android" | "web" => {
  try {
    return Capacitor.getPlatform() as "ios" | "android" | "web";
  } catch {
    return "web";
  }
};

export const APP_HOSTS = ["tkesteticaavancada.com.br", "www.tkesteticaavancada.com.br"];

/**
 * Converte uma URL recebida (universal link / app link) em caminho interno.
 * Retorna null se o host não for da clínica — nunca navegamos para domínios externos.
 */
export function deepLinkToPath(rawUrl: string): string | null {
  try {
    const url = new URL(rawUrl);
    if (url.protocol === "tkestetica:") {
      const path = `/${url.host}${url.pathname}`.replace(/\/+/g, "/");
      return `${path}${url.search}${url.hash}`;
    }
    if (url.protocol !== "https:" || !APP_HOSTS.includes(url.hostname)) return null;
    return `${url.pathname || "/"}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

/**
 * Decide o destino da rota "/" (HomeRedirect).
 * "wait" = sessão ou configuração ainda carregando: não redirecionar cedo.
 */
export function decideHomeRoute(state: {
  loading: boolean;
  hasUser: boolean;
  isNative: boolean;
  landingEnabled: boolean | null;
}): "wait" | "/dashboard" | "/auth" | "home" {
  if (state.loading) return "wait";
  if (state.hasUser) return "/dashboard";
  if (state.isNative) return "/auth";
  if (!state.landingEnabled) return "/auth";
  return "home";
}

/** Decide o que o botão Voltar do Android deve fazer. */
export function decideBackAction(state: {
  overlayOpen: boolean;
  canGoBack: boolean;
}): "closeOverlay" | "goBack" | "exit" {
  if (state.overlayOpen) return "closeOverlay";
  if (state.canGoBack) return "goBack";
  return "exit";
}
